import { useEffect } from 'react';

import { atom, useRecoilState } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { getShortUniqueId } from 'helpers/uniqueId';

const { persistAtom } = recoilPersist();

interface IGuest {
  guestId?: string;
}

export const guestAtom = atom<IGuest>({
  key: 'guestState',
  default: {
    guestId: undefined,
  },
  effects_UNSTABLE: [persistAtom],
});

export const useInitializeGuest = () => {
  const [, setGuest] = useRecoilState(guestAtom);
  useEffect(() => {
    setGuest(state =>
      state.guestId ? state : { guestId: getShortUniqueId() },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useGuest = () => {
  const [guest] = useRecoilState(guestAtom);
  return guest;
};
